module.exports = (__parcel__import__("bIOp5")).then(() => parcelRequire('fyWP3'));